import React from "react";
import styles from "./styles/ChannelPartnerProducts.module.css";
import { Reveal } from "../Home/common/Reveal";

import img1 from "../../../images/Contractors-n-Motor-starters.jpg";
import img2 from "../../../images/Meksec-IQ-R.jpg";
import img3 from "../../../images/SCADA-MC-Work-1.jpg";
import img4 from "../../../images/Motion-Controllers.jpg";
import img5 from "../../../images/HMI-GOT.jpg";
import img6 from "../../../images/Low-Voltage-Circuit-breaker.jpg";
import img7 from "../../../images/Power-Management-Meters.jpg";
import img8 from "../../../images/Inverters-FREQROL.jpg";
import img9 from "../../../images/Vertical-Type-Robot.jpg";
import img10 from "../../../images/Melsec-IQ-F.jpg";
import img11 from "../../../images/Melservo.jpg";
import img12 from "../../../images/Graphic-Operation-Controller.jpg";

const products = [
  {
    title: "CONTRACTORS & MOTOR STARTERS",
    image: img1,
    description:
      "Electromagnetic contactors are used to control loads in factory automation, air-conditioners, lighting equipment etc. Mitsubishi Electric offers a wide line-up of contactors to satisfy various control applications.",
  },
  {
    title: "PROGRAMMABLE CONTROLLERS",
    image: img2,
    description:
      "Offering a wide range of automation and processing technologies, including controllers, drive products, power distribution and control products, electric discharge machines, electron beam machines, laser processing machines and computerized numerical controllers.",
  },
  {
    title: "SCADA MC WORKS",
    image: img3,
    description:
      "MC Works64 can monitor plant-wide operation and support efficient plant operations. It is an integral software providing a variety of functions and refined user interfaces suitable for social infrastructure fields.",
  },
  {
    title: "MOTION CONTROLLERS",
    image: img4,
    description:
      "Controllers that provide highly accurate positioning control. The servo is controlled by way of a high-speed servo network SSCNET, making complex synchronous control easy.",
  },
  {
    title: "HUMAN MACHINE INTERFACES",
    image: img5,
    description:
      "Human-Machine Interfaces (HMIs)- GOT: The GOT series HMIs have been designed to deliver maximum usability. They contribute to our customer's needs to improve efficiency, increase productivity and create added-value, by allowing them to monitor information from PLCs, CNCs and other FA products.",
  },
  {
    title: "LOW VOLTAGE CIRCUIT BREAKERS",
    image: img6,
    description:
      "Mitsubishi Electric's low-use breakers and earth-leakage circuit breakers comply with overseas standards, including European and Chinese standards. A wide array of products, including the new eco-friendly WS-V series, responds to various energy-saving and space-saving needs of our clients.",
  },
  {
    title: "POWER MANAGEMENT METERS",
    image: img7,
    description:
      "Mitsubishi Electric's wide array of measuring devices suits various applications, such as quantifying, measuring, displaying, recording and monitoring electric power, current and voltage in plants and buildings.",
  },
  {
    title: "INVERTERS FR-EQROL",
    image: img8,
    description:
      "The FR-EQROL series general-purpose inverters allows changes to be made to the speed of three-phase induction motors freely and easily. An extensive line-up provides optimum control and energy conservation in a wide range of machines.",
  },
  {
    title: "INDUSTRIAL ROBOTS MELFA",
    image: img9,
    description:
      "Smaller, lighter and faster robots that are capable of managing heavier loads, both in terms of weight and functionality. Advanced developments at Mitsubishi Electric include the addition of a dedicated motor and controller fitted with a T6-bit RICS chip set.",
  },
  {
    title: "SIMPLE APPLICATION CONTROLLERS",
    image: img10,
    description:
      "The FX series can be easily used in all places where control is needed for the home, office or factory.",
  },
  {
    title: "DRIVE PRODUCTS – AC SERVOS",
    image: img11,
    description:
      "MELSERVO systems combine a servo motor and amp, and are ideal for controlling the moving parts of various machines and equipment. They are lightweight, low-cost and high-speed, offering competitive devices as a driving source for industrial machines.",
  },
  {
    title: "GRAPHIC OPERATION CONTROLLERS",
    image: img12,
    description:
      "Graphic Operation Controller (GOC) is an integrated controller with an intuitive HMI with Serial, Ethernet and MODBUS connectivity. The controller has an I/O capacity of 48 and it also supports analogue I/Os. GOC comes with an annunciator, PB lamps and customizable MIMIC.",
  },
];

export default function ChannelPartnerProducts() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {products.map((product, index) => (
            <Reveal key={product.title} delay={index * 80}>
              <article className={styles.product}>
                <div className={styles.imageWrap}>
                  <img
                    src={product.image}
                    alt={product.title}
                    className={styles.productImage}
                    loading="lazy"
                  />
                </div>
                <h3 className={styles.productTitle}>{product.title}</h3>
                <div className={styles.productAccent} aria-hidden="true" />
                <p className={styles.productDescription}>{product.description}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
